import React, { useCallback, useContext, useEffect, useRef } from 'react';
import mapboxgl from 'mapbox-gl';
import { makeStyles } from '@material-ui/core/styles';
import { ServiceAreaContext } from '../../Context';
import mapLoad, { addLayer, mapOnLoad } from './MapLoad';

mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_TOKEN;
let map = null;

const useStyles = makeStyles(() => ({
  mapContainer: {
    height: 'calc(100vh - 226px)',
  },
}));

const MapEdit = () => {
  const {
    data,
    editServiceAreas,
    setEditServiceAreas,
    serviceVehicle,
  } = useContext(ServiceAreaContext);
  const classes = useStyles();
  const mapperRef = useRef(null);
  const tempServiceAreas = useRef();
  tempServiceAreas.current = editServiceAreas;
  const togglePostalCode = useCallback(
    (e) => {
      e.preventDefault();
      const postal_code = e.features[0].properties.ZIP_CODE;
      if (postal_code) {
        const temp = [...tempServiceAreas.current];
        const index = temp.indexOf(postal_code);
        if (index > -1) {
          temp.splice(index, 1);
          setEditServiceAreas(temp);
        } else {
          setEditServiceAreas([...tempServiceAreas.current, postal_code]);
        }
      }
    },
    [setEditServiceAreas],
  );
  useEffect(() => {
    if (map) {
      map.remove();
    }
  }, []);
  // Effect for the inital loading map
  useEffect(() => {
    if (mapperRef) {
      map = mapLoad(mapperRef);
      mapOnLoad(map);
    }
  }, []);
  useEffect(() => {
    if (editServiceAreas && serviceVehicle) {
      map.on('load', () => {
        if (!map.getLayer(`us-zip-code-fill-layer-${serviceVehicle.id}`)) {
          addLayer(map, serviceVehicle.id, editServiceAreas);
        }
        if (!map.getLayer('us-zip-code-fill-layer')) {
          map.addLayer({
            id: 'us-zip-code-fill-layer',
            type: 'fill',
            source: 'us_zip_codes_simplified_2-28njg7',
            paint: {
              'fill-color': 'black',
              'fill-opacity': 0.3,
            },
            'source-layer': 'us_zip_codes_simplified_2-28njg7',
          });
          map.on('click', 'us-zip-code-fill-layer', togglePostalCode);
        }
      });
    }
  }, [editServiceAreas, serviceVehicle, togglePostalCode]);
  // Effect on edit
  useEffect(() => {
    if (
      data &&
      editServiceAreas &&
      serviceVehicle &&
      map.getSource('us_zip_codes_simplified_2-28njg7')
    ) {
      data.forEach(({ id }) => {
        if (map.getLayer(`us-zip-code-fill-layer-${id}`)) {
          map.removeLayer(`us-zip-code-fill-layer-${id}`);
        }
      });
      if (!map.getLayer(`us-zip-code-fill-layer-${serviceVehicle.id}`)) {
        addLayer(map, serviceVehicle.id, editServiceAreas);
      }
    }
  }, [
    serviceVehicle,
    editServiceAreas,
    map && map.getSource('us_zip_codes_simplified_2-28njg7'),
    togglePostalCode,
    data,
  ]);
  return <div ref={mapperRef} className={classes.mapContainer} />;
};

export default MapEdit;
